// extracted by mini-css-extract-plugin
export var fadeInOut = "_45-3";
export var icon = "_45-4";
export var savedIndicator = "_45-2";
export var savingIndicator = "_45-0";
export var spin = "_45-1";